module.exports = __webpack_public_path__ + "img/stack_4.522eab4b.png";